<div class="pt-0 templateBank row gx-0">
    <div class="col-md-6 p-5">
        @if(filteredTemplateBank.templateListByTopics.length === 0){
            <em class="text-secondary">{{'polls_settings.bank.search_empty' | translate}}</em>
        }
        @else {
            @for(templates of filteredTemplateBank.templateListByTopics; track templates){
                <article class="mb-5">
                    <h4>{{templates.title}}</h4>
                    <p class="description text-secondary pb-3">{{templates.description}}</p>
                    <div class="templates rounded">
                        @for(template of templates.templates; track template.label; let first = $first; let last = $last){
                            <poll-template-element [template]="template"
                                                       [isSelected]="template.id === selectedTemplate?.id"
                                                       [positionClass]="first ? 'first' : last ? 'last' : null"
                                                       [searchTerm]="searchTerm"
                                                       (onSelectTemplate)="setTemplateForPreview($event)"></poll-template-element>
                        }
                    </div>
                </article>
            }
        } 
    </div>
    <div class="col-md-6 bg-light mobile-fixed-col">
        <div class="preview-area p-2 px-md-5 pt-md-5">
            @if(selectedTemplate){
                <poll-preview [previewType]="selectedTemplate.answerOptions.type"
                              [poll]="templateForPreview"></poll-preview>
                <div class="mt-md-3 text-center btn-container">
                    <button class="btn btn-secondary px-5 m-1" data-cy="selectTemplate" (click)="selectTemplate(selectedTemplate)">{{'polls_settings.bank.cutomize' | translate}}</button>
                    <button class="btn btn-primary px-5 m-1" data-cy="postNow" (click)="postNow(selectedTemplate)">
                        @if(teams.length > 1){
                            {{'polls_settings.bank.post_to_teams' | translate: {'teamSize': teams.length} }}
                        }@else{
                           {{'polls_settings.bank.post' | translate}}
                        }
                    </button>
                </div>
            }@else{
                @if(filteredTemplateBank.templateListByTopics.length !== 0){
                    <div class="mt-5">
                        <div class="alert alert-info mt-5 text-center" role="alert">
                            <i class="far fa-info-square pe-2"></i> {{'poll_creation.preview_select_template' | translate}}
                        </div>
                    </div>
                }
            }
        </div>
    </div>
</div>
